import React from 'react';
import { HidingTooltip } from 'ui/Tooltip/HidingTooltip';

interface ITruncatedTooltipCellProps {
  value: string | null;
  maxWidth?: string;
}

export const TruncatedTooltipCell: React.FC<ITruncatedTooltipCellProps> = ({
  value,
  maxWidth = '180px'
}) => {
  if (!value) {
    return <span className="text-gray-60">—</span>;
  }

  return (
    <HidingTooltip
      position="bottom"
      renderTooltipContent={() => (
        <div className="p-10px max-w-[300px]">
          <span className="text-sm">{value}</span>
        </div>
      )}
    >
      <span className="block truncate" style={{ maxWidth }}>{value}</span>
    </HidingTooltip>
  );
};
